import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { config } from "../app-env/common";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, label, option, p, select } from "../van/van-tags";

export class Sp2CmdSetFwPage implements Route {
	async #listFirmwares(): Promise<void> {
		const req = this.#ctx.api.get("/firmwares/smartplug2");
		req.setSignedInUserAuth();

		const res = await this.#ctx.loadingScreen.waitFor(req.do());
		if (!res.ok) {
			this.#ctx.error.setText(await res.text());
			return;
		}

		this.#reactive.firmwares = await res.json();

		if (this.#reactive.firmwares.length) {
			this.#firmware = this.#reactive.firmwares[0];
		}
	}

	async #onClickSend(): Promise<void> {
		const req = this.#ctx.api.post(
			`/smartplug2s/${this.#reactive.imei}/cmds`,
		);
		const fwUrl = `https://${config.sp2gwHost}/firmwares/${this.#firmware}`;
		req.setJsonBody({
			CmdData: {
				Url: fwUrl,
			},
			CmdType: 0xac,
		});
		req.setSignedInUserAuth();

		const res = await this.#ctx.loadingScreen.waitFor(req.do());
		if (res.ok) {
			this.#ctx.router.up();
		} else {
			this.#ctx.error.setText(await res.text());
		}
	}

	#onSelectFirmware(e: Event): void {
		if (!(e.target instanceof HTMLSelectElement)) return;
		this.#firmware = e.target.value;
	}

	async refresh(match: Match): Promise<void> {
		if (!match.data?.imei) throw "missing path param: imei";
		this.#reactive.imei = match.data.imei;
		this.#listFirmwares();
	}

	#ctx: RouteContext;
	#firmware = "";
	#reactive = reactive({
		firmwares: [""],
		imei: "",
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title is-4" }, "SmartPlug2 - Set Firmware"),
			p({ class: "subtitle is-6" }, () => `IMEI ${this.#reactive.imei}`),
			div(
				{ class: "field" },
				label({ class: "label" }, "Firmware"),
				div(
					{ class: "control" },
					div({ class: "select" }, () =>
						select(
							{
								onchange: (e: Event) =>
									this.#onSelectFirmware(e),
							},
							this.#reactive.firmwares.map((filename) =>
								option({ value: filename }, filename),
							),
						),
					),
				),
			),
			div(
				{ class: "buttons" },
				button(
					{
						class: "button is-primary",
						onclick: () => this.#onClickSend(),
					},
					"Send command",
				),
				button(
					{
						class: "button is-danger",
						onclick: () => this.#ctx.router.up(),
					},
					"Back",
				),
			),
		);
	}
}
